import { useTranslation } from 'next-i18next';

import { useRouter } from '@boss/hooks';

import { useAccount } from '../../client-queries';
import { type FormType, useFormField, useFormSubmit, usePointOfSale } from '../../hooks';
import DynamicForm, { FormValues } from '../DynamicForm';
import { coloraStoreField } from './FormHelpers';
import { FormField } from '../Mappers/FormFieldMapper';

type Props = {
  type: FormType;
};

const RevokeOrderForm = ({ type }: Props) => {
  const { t } = useTranslation('forms');
  const { onSubmit, isSubmitting, isSuccess, reset, formRef } = useFormSubmit();
  const { firstname, lastname, email, phonenumber, orderid, message, termsandconditions } = useFormField();
  const { locale } = useRouter();
  const { data: account } = useAccount(locale ?? '');
  const { stores } = usePointOfSale();

  const storeField = coloraStoreField(stores, account?.preference?.shop, t('fields.storeRevokeOrder') ?? '');

  const baseFields: FormField[] = [
    firstname,
    lastname,
    email,
    phonenumber,
    orderid,
    storeField,
    { ...message, label: t('fields.messageRevokeOrder') ?? '' },
    termsandconditions,
  ];

  const handleSubmit = (vals: FormValues) => onSubmit(type, vals);

  return (
    <DynamicForm
      fields={baseFields}
      id={type}
      isSubmitting={isSubmitting}
      isSuccess={isSuccess}
      onCloseAlert={reset}
      onSubmit={handleSubmit}
      ref={formRef}
      variant="light"
    />
  );
};

export default RevokeOrderForm;
